<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4">
				<div class="row d-flex justify-content-between">
					<div class="col-md-3">
						<h1 class="h3 mb-0 text-gray-800">
							Despesa {{ dados.id }}
						</h1>
					</div>
					<div class="col-md-9 noprint d-flex justify-content-end">
						<button 
							class="btn btn-primary mr-1"
							@click="update">
							<i class="fas fa-edit"></i>
						</button>
						<button 
							class="btn btn-danger mr-1"
							@click="confirmDestroy()">
							<i class="fas fa-trash"></i>
						</button>
						<button 
					        @click="$router.go(-1)" 
					        class="btn btn-secondary">
				           	Voltar
				        </button>
				    </div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Informações -->
					<despesa-info 
						:dados="dados">
					</despesa-info>
				</div>
			</div>
		</div>
		<!-- Update -->
		<despesa-update 
			@reload="getDados">
		</despesa-update>
		<!-- Confirmação para excluir -->
        <bsh-confirm 
        	modal_id="confirm_destroy_despesa" 
        	:dado_id="$route.params.id" 
        	title="Deseja realmente cancelar esta despesa?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/despesas/destroy/'" 
        	@reload="back()">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/despesas/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(id){
				this.dado_id = id;
				$('#update_despesa').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_despesa').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>